import ClubInvoice from '../dto/ClubInvoice';

export default class Helper {
    getPricePerTime(pricePerTime) {
        const amount = (pricePerTime.gross.numerator / pricePerTime.gross.denominator).toFixed(2).replace('.', ',');
        const vat = (pricePerTime.vat.numerator / (pricePerTime.vat.denominator / 100)).toFixed(2).replace('.', ',');
        const type = pricePerTime.type;

        return `${amount} ${pricePerTime.currency} (inkl. ${vat}% MwSt.) ${this.translatePricePerTimeType(type)}`;
    }

    getDiscountedPricePerTime(pricePerTime, discountedPrice) {
        const amount = (discountedPrice.gross.numerator / discountedPrice.gross.denominator).toFixed(2).replace('.', ',');
        const vat = (pricePerTime.vat.numerator / pricePerTime.vat.denominator * 100).toFixed(2).replace('.', ',');
        const type = pricePerTime.type;

        return `${amount} ${pricePerTime.currency} (inkl. ${vat}% MwSt.) ${this.translatePricePerTimeType(type)}`;
    }

    getPrice(price) {
        const amount = (price.gross.numerator / price.gross.denominator).toFixed(2).replace('.', ',');
        const vat = (price.vat.numerator / price.vat.denominator * 100).toFixed(2);

        return `${amount} ${price.currency} (inkl. ${this.vatToString(vat).toString().replace('.', ',')}% MwSt.)`;
    }

    getMoney(money) {
        const amount = (money.numerator / money.denominator).toFixed(2);

        return `${amount} ${money.currency}`;
    }

    translatePricePerTimeType(type) {
        switch (type) {
            case 'oneTime':
                return 'einmalig';
            case 'perDay':
                return 'pro Tag';
            case 'perWeek':
                return 'pro Woche';
            case 'perMonth':
                return 'pro Monat';
            case 'perQuarter':
                return 'pro Quartal';
            case 'perHalfYear':
                return 'pro Halbjahr';
            case 'perYear':
                return 'pro Jahr';
            case 'perThreeYears':
                return 'pro 3 Jahre';
        }

        throw new Error(`undefined price per time type: ${type}`);
    }

    translatePaymentMethod(type, isDefault = false) {
        let name = '';

        switch (type) {
            case 'indefinite':
                name += 'Undefiniert';
                break;
            case 'cash':
                name += 'Barzahlung';
                break;
            case 'debit-card':
                name += 'Kartenzahlung';
                break;
            case 'bank-transfer':
                name += 'Überweisung';
                break;
            case 'sepa-debit':
                name += 'SEPA-Lastschrift';
                break;
            case 'sepa-credit-transfer':
                name += 'SEPA-Überweisung';
                break;
            default:
                throw new Error(`unknown payment method type ${type}`);
        }

        if (isDefault) {
            name += ' (Standard)';
        }

        return name;
    }

    translateInvoiceAmount(type) {
        switch (type) {
            case 'positive':
                return 'positiv';

            case 'negative':
                return 'negativ';

            case 'zero':
                return 'null';
        }

        throw new Error(`unknown invoice amount type"${type}"`);
    }

    translateInvoiceStatus(status) {
        switch (status) {
            case ClubInvoice.STATUS_OPEN:
                return 'offen';
            case ClubInvoice.STATUS_PAID:
                return 'bezahlt';
            case ClubInvoice.STATUS_CHARGEBACK:
                return 'Rücklastschrift';
            case ClubInvoice.STATUS_UNEQUAL:
                return 'Überzahlung/Unterzahlung';
        }
        throw new Error(`unknown invoice status "${status}"`);
    }

    translateDunningStatus(status) {
        status = Number(status);
        switch (status) {
            case 0:
                return 'ohne Mahnstatus';
            case 1:
                return 'Zahlungserinnerung';
            case 2:
                return '1. Mahnung';
            case 3:
                return '2. Mahnung';
            case 4:
                return '3. Mahnung';
        }
        throw new Error(`unknown dunning status "${status}"`);
    }

    translateChargebackReason(chargebackReason) {
        switch (chargebackReason) {
            case 'lackOfCover':
                return 'Mangels Deckung';
            case 'contradiction':
                return 'Aufgrund von Widerspruch';
            case 'accountDoesNotExist':
                return 'Konto existiert nicht';
        }
        throw new Error(`unknown chargeback reason "${chargebackReason}"`);
    }

    vatToString(vat) {
        const factor = 10 ** 2;
        return (Math.round(vat * factor) / factor);
    }

    formatDate(date) {
        if (date === null) {
            return '';
        }

        const parts = date.split('-');

        return `${parts[2]}.${parts[1]}.${parts[0]}`;
    }

    formatDateTime(date) {
        if (date === null) {
            return '';
        }

        const parts = date.split(' ');

        return `${this.formatDate(parts[0])} ${parts[1]}`;
    }

    today() {
        const date = new Date();

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    inXDays(days) {
        const date = new Date();
        date.setDate(date.getDate() + days);

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    oneWeekAgo() {
        const date = new Date();
        date.setDate(date.getDate() - 7);

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    oneMonthAgo() {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    oneYearAgo() {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 1);

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    firstDayOfCurrentMonth() {
        const date = new Date();

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        const day = '01';

        return [year, month, day].join('-');
    }

    lastDayOfCurrentMonth() {
        let date = new Date();
        date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const year = `${date.getFullYear()}`;
        let month = `${date.getMonth() + 1}`;
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day = `${date.getDate()}`;
        if (day.length < 2) {
            day = `0${day}`;
        }

        return [year, month, day].join('-');
    }

    getFilenameFromHeaders(headers) {
        const headerLine = headers['content-disposition'];
        const startFileNameIndex = headerLine.indexOf('"') + 1;
        const endFileNameIndex = headerLine.lastIndexOf('"');
        return headerLine.substring(startFileNameIndex, endFileNameIndex);
    }

    getSelectedInvoiceIds(bulkSelection) {
        const invoiceIds = [];
        Object.entries(bulkSelection).forEach((array) => {
            if (array[1] === true) {
                invoiceIds.push(array[0]);
            }
        });
        return invoiceIds;
    }

    hasFeature(feature) {
        const features = window.localStorage.getItem('kgr_features');
        return features !== null && features.includes(feature);
    }

    hasModule(module) {
        const modules = window.localStorage.getItem('kgr_modules');
        return modules !== null && modules.includes(module);
    }

    numberFormat(number, locale, currency) {
        if (typeof currency === 'string') {
            return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number);
        }
        return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(number);
    }

    getDeleteInvoiceButtonTitle(invoice) {
        if (invoice.isReverseInvoice && !invoice.deletable) {
            return invoice.notDeletableReasons.join(' ');
        } else if (invoice.canceled) {
            return 'Eine stornierte Rechnung kann nicht gelöscht werden';
        } else if (!invoice.deletable) {
            return 'Eine exportierte Rechnung kann nicht gelöscht werden';
        }
        return 'Rechnung löschen';
    }

    getPaymentInterval(fee) {
        if (fee.rollingIntervalType !== null) {
            switch (fee.rollingIntervalType) {
                case 'three_yearly':
                    return 'dreijährlich rollierend';
                case 'yearly':
                    return 'jährlich rollierend';
                case 'monthly':
                    return 'monatlich rollierend';
                default:
                    return `rollierend${fee.rollingIntervalType}`;
            }
        }
        const paymentInterval = fee.paymentInterval;
        switch (paymentInterval.type) {
            case '':
                return 'nach Kundenwunsch';

            case 'monthly':
                return `monatlich zum ${paymentInterval.monthly.day}.`;

            case 'monthlyEnd':
                if (paymentInterval.monthlyEnd.offset === 0) {
                    return 'zum Monatsende';
                } else {
                    return `${paymentInterval.monthlyEnd.offset} Tage vor Monatsende`;
                }

            case 'quarterly':
                if (paymentInterval.quarterly.offsetDay === 0 && paymentInterval.quarterly.offsetMonth === 0) {
                    return 'quartalsweise';
                } else if (paymentInterval.quarterly.offsetDay === 0) {
                    return `${paymentInterval.quarterly.offsetMonth} Monate nach Quartalsbeginn`;
                } else if (paymentInterval.quarterly.offsetMonth === 0) {
                    return `${paymentInterval.quarterly.offsetDay} Tage nach Quartalsbeginn`;
                } else {
                    return `${paymentInterval.quarterly.offsetDay} Tage und ${paymentInterval.quarterly.offsetMonth} Monate nach Quartalsbeginn`;
                }

            case 'halfYearly':
                if (paymentInterval.halfYearly.offsetDay === 0 && paymentInterval.halfYearly.offsetMonth === 0) {
                    return 'halbjährlich';
                } else if (paymentInterval.halfYearly.offsetDay === 0) {
                    return `${paymentInterval.halfYearly.offsetMonth} Monate nach Halbjahresbeginn`;
                } else if (paymentInterval.halfYearly.offsetMonth === 0) {
                    return `${paymentInterval.halfYearly.offsetDay} Tage nach Halbjahresbeginn`;
                } else {
                    return `${paymentInterval.halfYearly.offsetDay} Tage und ${paymentInterval.halfYearly.offsetMonth} Monate nach Halbjahresbeginn`;
                }

            case 'yearly':
                return `jährlich zum ${paymentInterval.yearly.day}. ${paymentInterval.yearly.month}.`;
        }

        throw new Error(`undefined payment interval: ${paymentInterval.type}`);
    }

    translatePaymentApproach(paymentApproach) {
        switch (paymentApproach) {
            case 'in_advance':
                return 'vorschüssig';

            case 'in_arrears':
                return 'nachschüssig';

            case 'undefined':
                return 'nach Kategorie';
        }

        throw new Error(`undefined payment approach: ${paymentApproach}`);
    }

    getApiDateFromString(string) {
        if (string === null) {
            return null;
        }
        const [year, month, day] = string.split('-');

        return {
            day: Number.parseInt(day),
            month: Number.parseInt(month),
            year: Number.parseInt(year),
        };
    }

    getDunningDialogText(dunningLevel, invoiceRecipient, currentDunningStatus) {
        if (dunningLevel === null) {
            return '';
        }
        let suffix = '';
        if (dunningLevel < currentDunningStatus) {
            suffix = '<br><br>Mahndokumente für höhere Mahnstufen, auch bereits per E-Mail verschickte, werden bei diesem Vorgang gelöscht.';
        }
        if (dunningLevel > 0) {
            return `Willst du für den/die RechnungsempfängerIn ${
                invoiceRecipient
            } den Mahnstatus auf ${
                this.translateDunningStatus(dunningLevel)
            } setzen?${suffix}`;
        } else {
            return `Willst du den Mahnstatus für den/die RechnungsempfängerIn ${invoiceRecipient} zurücknehmen?${suffix}`;
        }
    }
}
